// Shared constants for the Konva map editor/viewer implementation.
export const CANVAS_SAVE_DEBOUNCE_MS = 350;
export const ERASE_RADIUS = 30; // world-space px — pencil eraser half-width
export const DRAW_WIDTH = 30; // world-space px — pencil draw stroke width
export const MIN_FOG_BRUSH_SIZE = 1;
export const MAX_FOG_BRUSH_SIZE = 124;
export const ZOOM_STEP = 1.25; // multiplicative zoom factor per step
export const MIN_SCALE = 0.05; // 5%
export const MAX_SCALE = 8.0; // 800%
export const POSITION_ZOOM_STEP = 5; // image_zoom integer delta per mouse wheel tick in position-manager mode
/** Palette of 8 colours used by the layer edit modal. */
export const SHAPE_COLORS = ['#dc3545', '#fd7e14', '#ffc107', '#198754', '#0d6efd', '#6f42c1', '#d63384', '#ffffff'];
/** Default values applied to every newly created shape. */
export const SHAPE_DEFAULTS = { strokeWidth: 3, fillColor: 'transparent', fillOpacity: 0.2, aboveFog: false };
export const MIN_SHAPE_DIMENSION = 2; // prevent degenerate rectangles when resizing
export const SHAPE_TRANSFORMER_OPTIONS = {
  rotateEnabled: false,
  flipEnabled: false,
  keepRatio: false,
  enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
};
export const TOOLBAR_DEFAULT_TOOLS = { settings: null, fog: 'erase', shapes: 'shape-rect', position: 'position-manager' };
export const TOOLBAR_TOOLS = {
  settings: [],
  fog: ['draw', 'draw-rect', 'erase', 'erase-rect'],
  shapes: ['shape-rect', 'select'],
  position: ['position-manager']
};
export const TOOLBAR_URL_PARAM = 'toolbar';
